import { z } from "zod"

import { defaultMaxLength } from "./schema-constants"

/** Trim without a max. Compose other string schemas from this, or use for audited length exceptions. */
export const trimmedStringSchema = z.string().trim()

/** Trim + default max length — ordinary form/shared string fields. */
export const standardStringSchema = trimmedStringSchema.max(defaultMaxLength)
